export const redirectToUrl = (url: string) => {
  window.location.assign(url);
};
